/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Compose/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'



/** @type {import('Simple/types.js').View} */
export default function Compose({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal/Compose",
  onChange,
  isSubmitting
  
}) {
let messageComposeMessageValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'message',
})
let messageComposeMessageChangeData = fromData.useDataChange({ viewPath,
context: 'message_compose',
path: 'message',
})
let messageComposeMessageIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyLineheightM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.m'
        })
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 autoFocus={true}
 backgroundColor="#fff"
 borderColor={dtColorsNeutral200}
 borderStyle="solid"
 borderWidth={2}
 fontSize={dtTypographyFontsizeM}
 lineHeight={dtTypographyLineheightM}
 fontWeight={300}
 minHeight={30}
 maxHeight={500}
 paddingLeft={10}
 paddingTop={8}
 marginTop={0}
 resize="none"
 data="message_compose.message"
 value={messageComposeMessageValueData}
 onChange={messageComposeMessageChangeData}
 disabled={messageComposeMessageIsSubmittingData}
 placeholder="Message"
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}